import { Search } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDebounce } from '@/shared/hooks/use-debounce'
import { cn } from '@/shared/libs/cn'
import { Input } from '@/shared/ui/input'

interface TenantSearchBarProps {
  onSearch: (term: string) => void
  placeholder?: string
  className?: string
}

export function TenantSearchBar({ onSearch, placeholder, className }: TenantSearchBarProps) {
  const { t } = useTranslation()
  const [value, setValue] = useState('')
  const debouncedValue = useDebounce(value, 500)

  useEffect(() => {
    onSearch(debouncedValue)
  }, [debouncedValue]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={cn('relative max-w-[320px]', className)}>
      <Search size={14} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-zinc-400" />
      <Input
        className="pl-8"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder ?? t('tenant.searchPlaceholder')}
      />
    </div>
  )
}
